import { Link } from 'react-router'
import { useOptionalUser, userHasPermission  } from '#app/utils/user.ts'

export default function CarShowAndParadeIndex() {
	const user = useOptionalUser()
	const isCarShowAdmin = userHasPermission(user, 'read:carShowRegistration:any')

	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Car Show and Parade
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					{isCarShowAdmin && (
						<>
							<span>Welcome {user?.name ?? user?.displayUsername}</span>
							<Link
								to="/events/2025-car-show-vendor/registrants"
								className="mt-3 mb-3 flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-base font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
							>
								View Vendor/Trophy Registrants{' '}
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									fill="currentColor"
									className="ml-2 -mr-0.5 h-4 w-4"
									aria-hidden="true"
								>
									<path
										fillRule="evenodd"
										d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
										clipRule="evenodd"
									/>
								</svg>
							</Link>
						</>
					)}

					<Link
						to="/events/2025-parade"
						className="mt-3 flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						View Parade Details
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>

					<Link
						to="register"
						className="mt-3 flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						Register a Car
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>

					<Link
						to="/events/2025-car-show-vendor/register"
						className="mt-3 flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						Register for Vendor/Trophy
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>

					<img
						src="/images/ebhs/events/2025-car-show-poster-2.jpg"
						alt="poster for 2025 car show"
						className="w-full py-3"
					/>

					<Link
						to="register"
						className="flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						Register a Car
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>

					<Link
						to="/events/2025-car-show-vendor/register"
						className="mt-3 flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-2xl font-medium text-blue-700 shadow-sm hover:bg-blue-50 sm:px-8"
					>
						Register for Vendor/Trophy
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="currentColor"
							className="ml-2 -mr-0.5 h-4 w-4"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</Link>
				</div>
			</div>
		</>
	)
}
